namespace $ {

	export class $bog_max_house extends $giper_baza_dict.with({
		Address: $giper_baza_atom_text,
		Code: $giper_baza_atom_text,
	}) {}

}
